import React from 'react';

import { makeStyles } from '@material-ui/core';

import { useSelector } from 'react-redux';
import { OWNERSHIP_REDUCER } from '../../../../../redux/ReducerNames';

import ScrollableContainer from '../../../../utility/ScrollableContainer';

import OwnershipArea from '../../common/searcharea/SearchArea';
import OwnershipCriteria from '../../common/searcharea/Criteria';
import ResultList from './ResultList';
import SearchActions from './SearchActions';

const useStyles = makeStyles((theme) => style(theme));

function Search () {
    const classes = useStyles();
    const isResultsExpanded = useSelector(state => state[OWNERSHIP_REDUCER].isResultsExpanded);
    //  TODO - don't hard code the layer this references
    const features = useSelector(state => state.user.features);

    function onHandleCriteriaChange(tree) {
        console.log(tree);
        tree.children.find(f => f.field === 'proprietor_name')
        // runSearch ();
    }

    return (
        <>
            {
                !isResultsExpanded &&
                <>
                    <ScrollableContainer className={classes.root}>
                        <OwnershipArea 
                            reducerName={OWNERSHIP_REDUCER}
                            reducerAreaKey="ownershipSearchArea"
                            featureKey="ownershipSearch"
                            heading="1. Define your ownership area"
                        />
                        <div className={classes.border} />
                        <OwnershipCriteria 
                            tag="ownershipSearch"
                            reducerName={OWNERSHIP_REDUCER}
                            reducerAreaKey="ownershipSearchArea"
                            heading="2. Choose your ownership criteria"
                            layerId={features.ownershipSearch.layerId}
                            onHandleChange={onHandleCriteriaChange}
                            onHandleClear={onHandleCriteriaChange}
                        />
                    </ScrollableContainer>
                    <div className={classes.border} /> 
                    <div className={classes.root}>
                        <SearchActions />
                    </div>
                </>
            }
            { 
                Boolean(isResultsExpanded) && 
                <div className={classes.root}>
                    <ResultList />
                </div>
            }
        </>
    ); 
}

const style = theme => ({
    root: {
        padding: theme.constants.spacing.xl,
        '&> *:not(:last-child)':{
            marginBottom: theme.constants.verticalMargin
        }
    },
    border: {
        height: '2px',
        backgroundColor: theme.palette.background.border
    }
});

export default Search;